import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Renderdevice from "./rendersliplist";

//import {getdevice,getfacesite,getfacegroup} from '../../services/facescan';
import { getsliplist, GetZone, ConfirmByAccount,GetAppStatus } from "../../services/car";
import DatePicker from "react-datepicker";
import BranchContext from "../context/branch";
import Select from "../common/selectcustom";
import Input from "../common/inputfunction";
import FontAwesome from "react-fontawesome";
import Modalbill from "./billdetails";
import moment from "moment";
import ConfirmSubmit from "../common/confirmSubmit";
import ConfirmBill from "./confirmFinance";
import { toast } from "react-toastify";
import PrivilegeContext from "../context/privilege";

import ScrollToTop from "../common/ScrollToTop";
import ProgressBar from "../common/progressbar";

const Bookinglist = () => {
  const { menuItems } = useContext(PrivilegeContext);
  const [askConfirm, setaskConfirm] = useState(false);
  const [askConfirmbill, setaskConfirmbill] = useState(false);
  const {currentBranch } = useContext(BranchContext);
  const [search, setsearch] = useState("");
  const [name, setname] = useState("");
  const [lastupdate, setlastupdate] = useState(new Date());
  const [groupid, setgroupid] = useState(0);
  const [month, setmonth] = useState(0);
  const [id, setid] = useState(0);
  const [statusid, setstatusid] = useState(0);
  const [yearid, setyearid] = useState(2021);
  const [remark, setremark] = useState("");
  //const [value, setValue] = useState([1]);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [vload, setvload] = useState(false);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [total, setTotal] = useState(0);
  const [bookinglist, setbookinglist] = useState([]);
  const [statuslist, setstatuslist] = useState([]);
  const [bookingApp, setbookingApp] = useState([]);
  const [message, setmessage] = useState(
    "ท่านยืนยันการรับเงินของรายการนี้ใช่หรือไม่"
  );
  const [grouplist, setgrouplist] = useState([]);
  const [appid, setappid] = useState(0);
  const [showonscroll, setshowonscroll] = useState(false);
  const [onProgress, setonProgress] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    if (!currentBranch) return;
    if (!menuItems) return;
    if (!pageSize) return;
    if (onProgress) return;
    setbookinglist([]);
  }, [
    currentBranch,
    groupid,
    startDate,
    endDate,
    pageSize,
    lastupdate,
    showonscroll,
    menuItems,statusid,onProgress,search
  ]);

  useEffect(() => {
    if (!currentBranch) return;
  

    const loadData = async () => {
      const { data: result } = await GetZone();
      if (result.status === "success") {
        setgrouplist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await GetAppStatus();
      if (result.status === "success") {
        setstatuslist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);



  useEffect(() => {
    if (!currentBranch) return;

    if (!pageSize || !pageNumber) return;
    if (!menuItems) return;
    if (menuItems.length === 0) return;
    if (onProgress) return;

    setLoading(true);
    setError(false);

    const loadData = async () => {
      const { data: result } = await getsliplist(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        groupid,search,statusid,
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        setTotal(result.data.total);

        setbookinglist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [
    currentBranch,
    startDate,
    endDate,
    groupid,
    pageSize,
    pageNumber,
    showonscroll,
    menuItems,statusid,onProgress,search
  ]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }

      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handlegroupChange = (event) => {
    setgroupid(event.currentTarget.value);
    setsearch(name);
    setPageNumber(1);
  };

  const handleStatusChange = (event) =>{
    setstatusid(event.currentTarget.value);
    setsearch(name);
    setPageNumber(1);
  }

  const handleyearChange = (event) => {
    setPageNumber(1);
    setyearid(event.currentTarget.value);
    setsearch(name);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setPageNumber(1);
      setsearch(name);
    }
  };
  const handleOnClick = (id, levelid) => {
    setappid(levelid); 
    setid(id);
    if (levelid === 1) {
      setmessage("ท่านยืนยัน รับเงินของรายการนี้ใช่หรือไม่");
      setaskConfirm(true);
    } else if (levelid === 2) {
      setbookingApp([]);
      setremark("");
      const subdata = (bookinglist.filter(x=> x.id ===id))
      setbookingApp(subdata);
      setmessage("ท่านยืนยัน ออกใบเสร็จรับเงิน ของรายการนี้ใช่หรือไม่");
      setaskConfirmbill(true);
    }  
  };
  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };

  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };

  // console.log(billlist)

  const handleConfirmSubmit = () => {
    doSubmit();
    setaskConfirm(false);
  };
  const handleCancleSubmit = () => {
    setaskConfirm(false);
  };
  const doSubmit = async () => {
    setonProgress(true)
    try {
      const doc = {
        id: id,
        appid: appid,
        remark:remark
      };
    //  console.log(doc);
      const { data: result } = await ConfirmByAccount(doc);
      if (result.status === "success") {
        toast.success("บันทึกเสร็จเรียบร้อย");
        setonProgress(false)
      setremark("");
      } else {
        toast.error(result.message);
        setonProgress(false)
      setremark("");
      }
    } catch (err) {
      toast.error("Error");
      setremark("");
      setonProgress(false)
    }
  };

  const handleConfirm = () =>{
    doSubmit();
    setaskConfirmbill(false)

  }
  const handleCancle =() =>{
    setaskConfirmbill(false)
  }
  const handleTextchange = (event) => {
    setremark(event.currentTarget.value);
  };
  const handlenameTextchange = (event) => {
    setname(event.currentTarget.value);
  };
const handleSearchClick =() => {
  setsearch(name)
  setPageNumber(1);

}

  return (
    <>
    <ConfirmBill
     isOpen ={askConfirmbill}
     header ={message}
     list ={bookingApp}
     onConfirm={handleConfirm}
     onCancel={handleCancle}
     button1="OK"
     onChange ={handleTextchange}
     value={remark}
    />

    
      <ConfirmSubmit
        isOpen={askConfirm}
       
        onConfirm={handleConfirmSubmit}
        onCancel={handleCancleSubmit}
        message={message}
        button1="OK"
      />
      <div className="container-fluid">
        <div
          className="card text-center border-top bg-secondary"
          style={{ fontSize: "14px" }}
        >
          <span className="bg-info" style={{ fontSize: "20px" }}>
            รายละเอียดการโอน
          </span>
        </div>

        <div className="row">
          <div className="col-auto">
            <i>
              จากวันที่ <span className="label label-default"></span>
            </i>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>
          <div className="col-auto">
            <i>
              ถึงวันที่ <span className="label label-default"></span>
            </i>
            <div className="mt-1">
              <DatePicker
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={endDate}
                onChange={handleChangEndDate}
              />
            </div>
          </div>

          <div className="col-lg-3  col-sm-4 col-xs-12">
            <div className="form-group">
              <Select
                label="Zone"
                data={grouplist}
                value={groupid}
                textProperty="name"
                valueProperty="_id"
                onChange={handlegroupChange}
              />
            </div>
          </div>
          <div className="col-lg-3  col-sm-4 col-xs-12">
            <div className="form-group">
              <Select
                label="สถานะ"
                data={statuslist}
                value={statusid}
                textProperty="name"
                valueProperty="_id"
                onChange={handleStatusChange}
              />
            </div>
          </div>

          <div className="col-lg-3  col-sm-6 col-xs-12">
        <div className="form-group">
            <Input
                    name="name"
                    value={name}
                    label="ค้นหา"
                    placeholder="ระบุล๊อค"
                    onChange = {handlenameTextchange}
                    onClick = {handleSearchClick}
                    onKeyPress={handleKeyPress}
                    search="ค้นหา"
                  />
            </div>
          </div>
        </div>

   

        {/* <Header onChange={handleChange} handleDateChange={handleDateChange} /> */}
      </div>

      <div className="container">
        <div className="row m-1">
          <div className="col-lg-4  col-sm-6 col-xs-12">
            <span className="text-success">
              แสดงข้อมูล {bookinglist ? bookinglist.length : 0} / {total} รายการ
            </span>
          </div>
        </div>
      </div>

      {/* { showprogress && <ProgressBar bgcolor={"#6a1b9a"} completed={completed} />} */}
      {<ScrollToTop onClick={scrollToTop} />}

      <Renderdevice
        list={bookinglist}
        handleOnClick={handleOnClick}
        error={error}
        lastBookElementRef={lastBookElementRef}
      />
    </>
  );
};

export default Bookinglist;
